import {
  LinearProgress as MuiLinearProgress,
  linearProgressClasses as MuiLinearProgressClasses,
} from '@mui/material';
import type { LinearProgressProps as MuiLinearProgressProps } from '@mui/material';

export type LinearProgressProps = MuiLinearProgressProps;

export const LinearProgress = (props: MuiLinearProgressProps) => <MuiLinearProgress {...props} />;

export const linearProgressClasses = MuiLinearProgressClasses;
